const map = {
	"./ar/notifications.json": [
		60858,
		[
			858
		]
	],
	"./de/notifications.json": [
		72406,
		[
			2406
		]
	],
	"./en/notifications.json": [
		9034,
		[
			9034
		]
	],
	"./es/notifications.json": [
		45261,
		[
			5261
		]
	],
	"./fa/notifications.json": [
		55068,
		[]
	],
	"./fr/notifications.json": [
		58821,
		[
			8821
		]
	],
	"./ja/notifications.json": [
		20848,
		[
			848
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 28972;
module.exports = webpackAsyncContext;